Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      count: 0,
      loggedIn:false
    },
    mutations: {
      loggedIn (state, value) {
        state.loggedIn = value;
      }
    },
    getters: {
      loggedIn: state => {
        return state.loggedIn
      }
    }
})